const dict = {

}


dict.pokemon = [
    {
        "sort": "Speedster",
        "name": "Absol",
        "label": "阿勃梭鲁"
    },
    {
        "sort": "All-Rounder",
        "name": "Aegislash",
        "label": "坚盾剑怪"
    },
    {
        "sort": "Supporter",
        "name": "Alcremie",
        "label": "霜奶仙"
    },
    {
        "sort": "Attacker",
        "name": "Armarouge",
        "label": "红莲铠骑"
    },
    {
        "sort": "All-Rounder",
        "name": "Azumarill",
        "label": "玛力露丽"
    },
    {
        "sort": "Defender",
        "name": "Blastoise",
        "label": "水箭龟"
    },
    {
        "sort": "All-Rounder",
        "name": "Blaziken",
        "label": "火焰鸡"
    },
    {
        "sort": "Supporter",
        "name": "Blissey",
        "label": "幸福蛋"
    },
    {
        "sort": "All-Rounder",
        "name": "Buzzwole",
        "label": "爆肌蚊"
    },
    {
        "sort": "All-Rounder",
        "name": "Ceruledge",
        "label": "苍炎刃鬼"
    },
    {
        "sort": "Attacker",
        "name": "Chandelure",
        "label": "水晶灯火灵"
    },
    {
        "sort": "All-Rounder",
        "name": "Charizard",
        "label": "喷火龙"
    },
    {
        "sort": "All-Rounder",
        "name": "Mega Charizard X",
        "label": "超级喷火龙X"
    },
    {
        "sort":"All-Rounder",
        "name": "Mega Charizard Y",
        "label": "超级喷火龙Y"
    },
    {
        "sort": "Attacker",
        "name": "Cinderace",
        "label": "闪焰王牌"
    },
    {
        "sort": "Supporter",
        "name": "Clefable",
        "label": "皮可西"
    },
    {
        "sort": "Supporter",
        "name": "Comfey",
        "label": "花环疗疗"
    },
    {
        "sort": "Attacker",
        "name": "Cramorant",
        "label": "古月鸟"
    },
    {
        "sort": "Defender",
        "name": "Crustle",
        "label": "岩殿居蟹"
    },
    {
        "sort": "Speedster",
        "name": "Darkrai",
        "label": "达克莱伊"
    },
    {
        "sort": "Attacker",
        "name": "Decidueye",
        "label": "木木枭"
    },
    {
        "sort": "Attacker",
        "name": "Delphox",
        "label": "妖火红狐"
    },
    {
        "sort": "All-Rounder",
        "name": "Dhelmise",
        "label": "破破舵轮"
    },
    {
        "sort": "Speedster",
        "name": "Dodrio",
        "label": "嘟嘟利"
    },
    {
        "sort": "Attacker",
        "name": "Dragapult",
        "label": "多龙巴鲁托"
    },
    {
        "sort": "All-Rounder",
        "name": "Dragonite",
        "label": "快龙"
    },
    {
        "sort": "Attacker",
        "name": "Duraludon",
        "label": "铝钢龙"
    },
    {
        "sort": "Supporter",
        "name": "Eldegoss",
        "label": "白蓬蓬"
    },
    {
        "sort": "All-Rounder",
        "name": "Empoleon",
        "label": "帝王拿波"
    },
    {
        "sort": "Attacker",
        "name": "Espeon",
        "label": "太阳伊布"
    },
    {
        "sort": "All-Rounder",
        "name": "Falinks",
        "label": "列阵兵"
    },
    {
        "sort": "All-Rounder",
        "name": "Garchomp",
        "label": "烈咬陆鲨"
    },
    {
        "sort": "Attacker",
        "name": "Gardevoir",
        "label": "沙奈朵"
    },
    {
        "sort": "Speedster",
        "name": "Gengar",
        "label": "耿鬼"
    },
    {
        "sort": "Attacker",
        "name": "Glaceon",
        "label": "冰伊布"
    },
    {
        "sort": "Defender",
        "name": "Goodra",
        "label": "黏美龙"
    },
    {
        "sort": "Defender",
        "name": "Greedent",
        "label": "藏饱栗鼠"
    },
    {
        "sort": "Attacker",
        "name": "Greninja",
        "label": "甲贺忍蛙"
    },
    {
        "sort": "All-Rounder",
        "name": "Gyarados",
        "label": "暴鲤龙"
    },
    {
        "sort": "All-Rounder",
        "name": "Mega Gyarados",
        "label": "超级暴鲤龙"
    },
    {
        "sort": "Defender",
        "name": "Ho-Oh",
        "label": "凤王"
    },
    {
        "sort": "Supporter",
        "name": "Hoopa",
        "label": "胡帕"
    },
    {
        "sort": "Attacker",
        "name": "Inteleon",
        "label": "千面避役"
    },
    {
        "sort": "Defender",
        "name": "Lapras",
        "label": "拉普拉斯"
    },
    {
        "sort": "Attacker",
        "name": "Latias",
        "label": "拉帝亚斯"
    },
    {
        "sort": "Attacker",
        "name": "Latios",
        "label": "拉帝欧斯"
    },
    {
        "sort": "Speedster",
        "name": "Leafeon",
        "label": "叶伊布"
    },
    {
        "sort": "All-Rounder",
        "name": "Lucario",
        "label": "路卡利欧"
    },
    {
        "sort": "All-Rounder",
        "name": "Mega Lucario",
        "label": "超级路卡利欧"
    },
    {
        "sort": "All-Rounder",
        "name": "Machamp",
        "label": "怪力"
    },
    {
        "sort": "Defender",
        "name": "Mamoswine",
        "label": "象牙猪"
    },
    {
        "sort": "Speedster",
        "name": "Meowscarada",
        "label": "魔幻假面喵"
    },
    {
        "sort": "Speedster",
        "name": "Meowth",
        "label": "喵喵"
    },
    {
        "sort": "All-Rounder",
        "name": "Metagross",
        "label": "巨金怪"
    },
    {
        "sort": "Attacker",
        "name": "Mew",
        "label": "梦幻"
    },
    {
        "sort": "All-Rounder",
        "name": "MewtwoX",
        "label": "超梦X"
    },
    {
        "sort": "Attacker",
        "name": "MewtwoY",
        "label": "超梦Y"
    },
    {
        "sort": "All-Rounder",
        "name": "Mimikyu",
        "label": "谜拟Q"
    },
    {
        "sort": "Attacker",
        "name": "Miraidon",
        "label": "密勒顿"
    },
    {
        "sort": "Supporter",
        "name": "Mr.Mime",
        "label": "魔墙人偶"
    },
    {
        "sort": "Attacker",
        "name": "Ninetales",
        "label": "阿罗拉九尾"
    },
    {
        "sort": "All-Rounder",
        "name": "Pawmot",
        "label": "巴布土拨"
    },
    {
        "sort": "Attacker",
        "name": "Pikachu",
        "label": "皮卡丘"
    },
    {
        "sort": "Supporter",
        "name": "Psyduck",
        "label":"可达鸭"
    },
    {
        "sort": "Attacker",
        "name": "Raichu",
        "label": "阿罗拉雷丘"
    },
    {
        "sort": "Speedster",
        "name": "Rapidash",
        "label":"伽勒尔烈焰马"
    },
    {
        "sort": "Supporter",
        "name": "Sableye",
        "label": "勾魂眼"
    },
    {
        "sort": "All-Rounder",
        "name": "Scizor",
        "label": "巨钳螳螂"
    },
    {
        "sort": "All-Rounder",
        "name": "Scyther",
        "label": "飞天螳螂"
    },
    {
        "sort": "All-Rounder",
        "name": "Sirfetch'd",
        "label":"葱游兵"
    },
    {
        "sort": "Defender",
        "name": "Slowbro",
        "label": "呆壳兽"
    },
    {
        "sort": "Defender",
        "name": "Snorlax",
        "label": "卡比兽"
    },
    {
        "sort": "All-Rounder",
        "name": "Suicune",
        "label": "水君"
    },
    {
        "sort": "Attacker",
        "name": "Sylveon",
        "label": "仙子伊布"
    },
    {
        "sort": "Speedster",
        "name": "Talonflame",
        "label": "烈箭鹰"
    },
    {
        "sort": "All-Rounder",
        "name": "Tinkaton",
        "label":"巨锻匠"
    },
    {
        "sort": "Defender",
        "name": "Trevenant",
        "label": "朽木妖"
    },
    {
        "sort": "All-Rounder",
        "name": "Tsareena",
        "label": "甜冷美后"
    },
    {
        "sort": "All-Rounder",
        "name": "Tyranitar",
        "label": "班吉拉斯"
    },
    {
        "sort": "Defender",
        "name": "Umbreon",
        "label": "月亮伊布"
    },
    {
        "sort": "All-Rounder",
        "name": "Urshifu_Single",
        "label": "武道熊师-一击流"
    },
    {
        "sort": "All-Rounder",
        "name": "Urshifu_Rapid",
        "label": "武道熊师-连击流"
    },
    {
        "sort": "Defender",
        "name": "Vaporeon",
        "label": "水伊布"
    },
    {
        "sort": "Attacker",
        "name": "Venusaur",
        "label": "妙蛙花"
    },
    {
        "sort": "Supporter",
        "name": "Wigglytuff",
        "label": "胖可丁"
    },
    {
        "sort": "All-Rounder",
        "name": "Zacian",
        "label": "苍响"
    },
    {
        "sort": "Speedster",
        "name": "Zeraora",
        "label": "捷拉奥拉"
    },
    {
        "sort": "Speedster",
        "name": "Zoroark",
        "label": "索罗亚克"
    }
]


dict.pokemonSort = [
    {
        "label": "攻击型",
        "name":"Attacker",
        "value": "Attacker"
    },
    {
        "label": "防御型",
        "name": "Defender",
        "value": "Defender"
    },
    {
        "label": "敏捷型",
        "name": "Speedster",
        "value": "Speedster"
    },
    {
        "label": "辅助型",
        "name": "Supporter",
        "value": "Supporter"
    },
    {
        "label": "平衡型",
        "name": "All-Rounder",
        "value": "All-Rounder"
    }
]


dict.pokemonSortAll = [
    {
        "label": "所有",
        "value": "all"
    },
    {
        "label": "攻击型",
        "value": "Attacker"
    },
    {
        "label": "防御型",
        "value": "Defender"
    },
    {
        "label": "敏捷型",
        "value": "Speedster"
    },
    {
        "label": "辅助型",
        "value": "Supporter"
    },
    {
        "label": "平衡型",
        "value": "All-Rounder"
    }
]

dict.skills = [
    {
        "name": "Absol",
        "label": "阿勃梭鲁",
        "skillGroup1": [
            {
                "en": "Night Slash",
                "zh": "暗袭要害"
            },
            {
                "en": "Pursuit",
                "zh": "追打"
            }
        ],
        "skillGroup2": [
            {
                "en": "Psycho Cut",
                "zh": "精神利刃"
            },
            {
                "en": "Sucker Punch",
                "zh": "突袭"
            }
        ]
    },
    {
        "name": "Aegislash",
        "label": "坚盾剑怪",
        "skillGroup1": [
            {
                "en": "Sacred Sword",
                "zh": "圣剑"
            },
            {
                "en": "Shadow Claw",
                "zh": "暗影爪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Wide Guard",
                "zh": "广域防守"
            },
            {
                "en": "Iron Head",
                "zh": "铁头"
            }
        ]
    },
    {
        "name": "Alcremie",
        "label": "霜奶仙",
        "skillGroup1": [
            {
                "en": "Decorate",
                "zh": "装饰"
            },
            {
                "en": "Recover",
                "zh": "自我再生"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dazzling Gleam",
                "zh": "魔法闪耀"
            },
            {
                "en": "Sweet Scent",
                "zh": "甜甜香气"
            }
        ]
    },
    {
        "name": "Armarouge",
        "label": "红莲铠骑",
        "skillGroup1": [
            {
                "en": "Fire Spin",
                "zh": "火焰漩涡"
            },
            {
                "en": "Armor Cannon",
                "zh": "凯农炮"
            }
        ],
        "skillGroup2": [
            {
                "en": "Flame Charge",
                "zh": "蓄能焰袭"
            },
            {
                "en": "Psyshock",
                "zh": "精神冲击"
            }
        ]
    },
    {
        "name": "Azumarill",
        "label": "玛力露丽",
        "skillGroup1": [
            {
                "en": "Play Rough",
                "zh": "嬉闹"
            },
            {
                "en": "Water Pulse",
                "zh": "水之波动"
            }
        ],
        "skillGroup2": [
            {
                "en": "Whirlpool",
                "zh": "潮旋"
            },
            {
                "en": "Aqua Tail",
                "zh": "水流尾"
            }
        ]
    },
    {
        "name": "Blastoise",
        "label": "水箭龟",
        "skillGroup1": [
            {
                "en": "Hydro Pump",
                "zh": "水炮"
            },
            {
                "en": "Water Spout",
                "zh": "喷水"
            }
        ],
        "skillGroup2": [
            {
                "en": "Surf",
                "zh": "冲浪"
            },
            {
                "en": "Rapid Spin",
                "zh": "高速旋转"
            }
        ]
    },
    {
        "name": "Blaziken",
        "label": "火焰鸡",
        "skillGroup1": [
            {
                "en": "Fire Punch",
                "zh": "火焰拳"
            },
            {
                "en": "Overheat",
                "zh": "过热"
            }
        ],
        "skillGroup2": [
            {
                "en": "Focus Blast",
                "zh": "真气弹"
            },
            {
                "en": "Blaze Kick",
                "zh": "火焰踢"
            }
        ]
    },
    {
        "name": "Blissey",
        "label": "幸福蛋",
        "skillGroup1": [
            {
                "en": "Egg Bomb",
                "zh": "炸蛋"
            },
            {
                "en": "Helping Hand",
                "zh": "帮助"
            }
        ],
        "skillGroup2": [
            {
                "en": "Soft-Boiled",
                "zh": "生蛋"
            },
            {
                "en": "Safeguard",
                "zh": "神秘守护"
            }
        ]
    },
    {
        "name": "Buzzwole",
        "label": "爆肌蚊",
        "skillGroup1": [
            {
                "en": "Lunge",
                "zh": "猛扑"
            },
            {
                "en": "Smack Down",
                "zh": "击落"
            }
        ],
        "skillGroup2": [
            {
                "en": "Leech Life",
                "zh": "吸血"
            },
            {
                "en": "Superpower",
                "zh": "蛮力"
            }
        ]
    },
    {
        "name": "Ceruledge",
        "label": "苍炎刃鬼",
        "skillGroup1": [
            {
                "en": "Bitter Blade",
                "zh": "悔念剑"
            },
            {
                "en": "Psycho Cut",
                "zh": "精神利刃"
            }
        ],
        "skillGroup2": [
            {
                "en": "Phantom Force",
                "zh": "潜灵奇袭"
            },
            {
                "en": "Flame Charge",
                "zh": "蓄能焰袭"
            }
        ]
    },
    {
        "name": "Chandelure",
        "label": "水晶灯火灵",
        "skillGroup1": [
            {
                "en": "Flamethrower",
                "zh": "喷射火焰"
            },
            {
                "en": "Overheat",
                "zh": "过热"
            }
        ],
        "skillGroup2": [
            {
                "en": "Poltergeist",
                "zh": "灵骚"
            },
            {
                "en": "Imprison",
                "zh": "封印"
            }
        ]
    },
    {
        "name": "Charizard",
        "label": "喷火龙",
        "skillGroup1": [
            {
                "en": "Flamethrower",
                "zh": "喷射火焰"
            },
            {
                "en": "Fire Punch",
                "zh": "火焰拳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Fire Blast",
                "zh": "大字爆炎"
            },
            {
                "en": "Flare Blitz",
                "zh": "闪焰冲锋"
            }
        ]
    },
    {
        "name": "Mega Charizard X",
        "label": "超级喷火龙X",
        "skillGroup1": [
            {
                "en": "Fire Punch",
                "zh":"火焰拳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Flare Blitz",
                "zh":"闪焰冲锋"
            }
        ]
    },
    {
        "name": "Mega Charizard Y",
        "label": "超级喷火龙Y",
        "skillGroup1": [
            {
                "en": "Flamethrower",
                "zh":"喷射火焰"
            }
        ],
        "skillGroup2": [
            {
                "en": "Fire Blast",
                "zh": "大字爆炎"
            }
        ]
    },
    {
        "name": "Cinderace",
        "label": "闪焰王牌",
        "skillGroup1": [
            {
                "en": "Pyro Ball",
                "zh": "火焰球"
            },
            {
                "en": "Blaze Kick",
                "zh": "火焰踢"
            }
        ],
        "skillGroup2": [
            {
                "en": "Flame Charge",
                "zh": "蓄能焰袭"
            },
            {
                "en": "Feint",
                "zh": "佯攻"
            }
        ]
    },
    {
        "name": "Clefable",
        "label": "皮可西",
        "skillGroup1": [
            {
                "en": "Moonlight",
                "zh": "月光"
            },
            {
                "en": "Draining Kiss",
                "zh": "吸取之吻"
            }
        ],
        "skillGroup2": [
            {
                "en": "Gravity",
                "zh": "重力"
            },
            {
                "en": "Follow Me",
                "zh": "看我嘛"
            }
        ]
    },
    {
        "name": "Comfey",
        "label": "花环疗疗",
        "skillGroup1": [
            {
                "en": "Floral Healing",
                "zh": "花疗"
            },
            {
                "en": "Sweet Kiss",
                "zh": "天使之吻"
            }
        ],
        "skillGroup2": [
            {
                "en": "Magical Leaf",
                "zh": "魔法叶"
            },
            {
                "en": "Grass Knot",
                "zh": "打草结"
            }
        ]
    },
    {
        "name": "Cramorant",
        "label": "古月鸟",
        "skillGroup1": [
            {
                "en": "Surf",
                "zh": "冲浪"
            },
            {
                "en": "Dive",
                "zh": "潜水"
            }
        ],
        "skillGroup2": [
            {
                "en": "Hurricane",
                "zh": "暴风"
            },
            {
                "en": "Air Slash",
                "zh": "空气之刃"
            }
        ]
    },
    {
        "name": "Crustle",
        "label": "岩殿居蟹",
        "skillGroup1": [
            {
                "en": "Rock Tomb",
                "zh": "岩石封闭"
            },
            {
                "en": "Shell Smash",
                "zh": "破壳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Stealth Rock",
                "zh": "隐形岩"
            },
            {
                "en": "X-Scissor",
                "zh": "十字剪"
            }
        ]
    },
    {
        "name": "Darkrai",
        "label": "达克莱伊",
        "skillGroup1": [
            {
                "en": "Dark Void",
                "zh": "暗黑洞"
            },
            {
                "en": "Shadow Claw",
                "zh": "暗影爪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Nasty Plot",
                "zh": "诡计"
            },
            {
                "en": "Dark Pulse",
                "zh": "恶之波动"
            }
        ]
    },
    {
        "name": "Decidueye",
        "label": "木木枭",
        "skillGroup1": [
            {
                "en": "Razor Leaf",
                "zh": "飞叶快刀"
            },
            {
                "en": "Spirit Shackle",
                "zh": "缝影"
            }
        ],
        "skillGroup2": [
            {
                "en": "Leaf Storm",
                "zh": "飞叶风暴"
            },
            {
                "en": "Shadow Sneak",
                "zh": "影子偷袭"
            }
        ]
    },
    {
        "name": "Delphox",
        "label": "妖火红狐",
        "skillGroup1": [
            {
                "en": "Fire Blast",
                "zh": "大字爆炎"
            },
            {
                "en": "Mystical Fire",
                "zh": "魔法火焰"
            }
        ],
        "skillGroup2": [
            {
                "en": "Fire Spin",
                "zh": "火焰漩涡"
            },
            {
                "en": "Flame Charge",
                "zh": "蓄能焰袭"
            }
        ]
    },
    {
        "name": "Dhelmise",
        "label": "破破舵轮",
        "skillGroup1": [
            {
                "en": "Power Whip",
                "zh": "强力鞭打"
            },
            {
                "en": "Whirlpool",
                "zh": "潮旋"
            }
        ],
        "skillGroup2": [
            {
                "en": "Anchor Shot",
                "zh": "掷锚"
            },
            {
                "en": "Heavy Slam",
                "zh": "重磅冲撞"
            }
        ]
    },
    {
        "name": "Dodrio",
        "label": "嘟嘟利",
        "skillGroup1": [
            {
                "en": "Tri Attack",
                "zh": "三重攻击"
            },
            {
                "en": "Drill Peck",
                "zh": "啄钻"
            }
        ],
        "skillGroup2": [
            {
                "en": "Agility",
                "zh": "高速移动"
            },
            {
                "en": "Jump Kick",
                "zh": "飞踢"
            }
        ]
    },
    {
        "name": "Dragapult",
        "label": "多龙巴鲁托",
        "skillGroup1": [
            {
                "en": "Dragon Breath",
                "zh": "龙息"
            },
            {
                "en": "Shadow Ball",
                "zh": "暗影球"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dragon Dance",
                "zh": "龙之舞"
            },
            {
                "en": "Phantom Force",
                "zh": "潜灵奇袭"
            }
        ]
    },
    {
        "name": "Dragonite",
        "label": "快龙",
        "skillGroup1": [
            {
                "en": "Dragon Dance",
                "zh": "龙之舞"
            },
            {
                "en": "Extreme Speed",
                "zh": "神速"
            }
        ],
        "skillGroup2": [
            {
                "en": "Hyper Beam",
                "zh": "破坏光线"
            },
            {
                "en": "Outrage",
                "zh": "逆鳞"
            }
        ]
    },
    {
        "name": "Duraludon",
        "label": "铝钢龙",
        "skillGroup1": [
            {
                "en": "Flash Cannon",
                "zh": "加农光炮"
            },
            {
                "en": "Dragon Pulse",
                "zh": "龙之波动"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dragon Tail",
                "zh": "龙尾"
            },
            {
                "en": "Stealth Rock",
                "zh": "隐形岩"
            }
        ]
    },
    {
        "name": "Eldegoss",
        "label": "白蓬蓬",
        "skillGroup1": [
            {
                "en": "Pollen Puff",
                "zh": "花粉团"
            },
            {
                "en": "Leaf Tornado",
                "zh": "青草搅拌器"
            }
        ],
        "skillGroup2": [
            {
                "en": "Cotton Guard",
                "zh": "棉花防守"
            },
            {
                "en": "Cotton Spore",
                "zh": "棉孢子"
            }
        ]
    },
    {
        "name": "Empoleon",
        "label": "帝王拿波",
        "skillGroup1": [
            {
                "en": "Hydro Cannon",
                "zh": "加农水炮"
            },
            {
                "en": "Whirlpool",
                "zh":"潮旋"
            }
        ],
        "skillGroup2": [
            {
                "en": "Metal Claw",
                "zh": "金属爪"
            },
            {
                "en": "Aqua Jet",
                "zh": "水流喷射"
            }
        ]
    },
    {
        "name": "Espeon",
        "label": "太阳伊布",
        "skillGroup1": [
            {
                "en": "Psyshock",
                "zh": "精神冲击"
            },
            {
                "en": "Stored Power",
                "zh": "辅助力量"
            }
        ],
        "skillGroup2": [
            {
                "en": "Psybeam",
                "zh": "幻象光线"
            },
            {
                "en": "Future Sight",
                "zh": "预知未来"
            }
        ]
    },
    {
        "name": "Falinks",
        "label": "列阵兵",
        "skillGroup1": [
            {
                "en": "Megahorn",
                "zh": "超级角击"
            },
            {
                "en": "Iron Head",
                "zh": "铁头"
            }
        ],
        "skillGroup2": [
            {
                "en": "No Retreat",
                "zh": "背水一战"
            },
            {
                "en": "Beat Up",
                "zh": "围攻"
            }
        ]
    },
    {
        "name": "Garchomp",
        "label": "烈咬陆鲨",
        "skillGroup1": [
            {
                "en": "Dig",
                "zh": "挖洞"
            },
            {
                "en": "Dragon Rush",
                "zh": "龙之俯冲"
            }
        ],
        "skillGroup2": [
            {
                "en": "Earthquake",
                "zh": "地震"
            },
            {
                "en": "Dragon Claw",
                "zh": "龙爪"
            }
        ]
    },
    {
        "name": "Gardevoir",
        "label": "沙奈朵",
        "skillGroup1": [
            {
                "en": "Psychic",
                "zh": "精神强念"
            },
            {
                "en": "Moonblast",
                "zh": "月亮之力"
            }
        ],
        "skillGroup2": [
            {
                "en": "Psyshock",
                "zh": "精神冲击"
            },
            {
                "en": "Future Sight",
                "zh": "预知未来"
            }
        ]
    },
    {
        "name": "Gengar",
        "label": "耿鬼",
        "skillGroup1": [
            {
                "en": "Shadow Ball",
                "zh": "暗影球"
            },
            {
                "en": "Sludge Bomb",
                "zh": "污泥炸弹"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dream Eater",
                "zh": "食梦"
            },
            {
                "en": "Hex",
                "zh": "祸不单行"
            }
        ]
    },
    {
        "name": "Glaceon",
        "label": "冰伊布",
        "skillGroup1": [
            {
                "en": "Icicle Spear",
                "zh": "冰锥"
            },
            {
                "en": "Icy Wind",
                "zh": "冻风"
            }
        ],
        "skillGroup2": [
            {
                "en": "Ice Shard",
                "zh": "冰砾"
            },
            {
                "en": "Freeze Dry",
                "zh": "冷冻干燥"
            }
        ]
    },
    {
        "name": "Goodra",
        "label": "黏美龙",
        "skillGroup1": [
            {
                "en": "Muddy Water",
                "zh": "浊流"
            },
            {
                "en": "Dragon Pulse",
                "zh": "龙之波动"
            }
        ],
        "skillGroup2": [
            {
                "en": "Power Whip",
                "zh": "强力鞭打"
            },
            {
                "en": "Acid Spray",
                "zh": "酸液炸弹"
            }
        ]
    },
    {
        "name": "Greedent",
        "label": "藏饱栗鼠",
        "skillGroup1": [
            {
                "en": "Bullet Seed",
                "zh": "种子机关枪"
            },
            {
                "en": "Belch",
                "zh": "打嗝"
            }
        ],
        "skillGroup2": [
            {
                "en": "Stuff Cheeks",
                "zh": "大快朵颐"
            },
            {
                "en": "Covet",
                "zh": "渴望"
            }
        ]
    },
    {
        "name": "Greninja",
        "label": "甲贺忍蛙",
        "skillGroup1": [
            {
                "en": "Water Shuriken",
                "zh": "飞水手里剑"
            },
            {
                "en": "Surf",
                "zh": "冲浪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Double Team",
                "zh": "影子分身"
            },
            {
                "en": "Smokescreen",
                "zh": "烟幕"
            }
        ]
    },
    {
        "name": "Gyarados",
        "label": "暴鲤龙",
        "skillGroup1": [
            {
                "en": "Dragon Breath",
                "zh": "龙息"
            },
            {
                "en": "Aqua Tail",
                "zh": "水流尾"
            }
        ],
        "skillGroup2": [
            {
                "en": "Waterfall",
                "zh": "攀瀑"
            },
            {
                "en": "Bounce",
                "zh": "弹跳"
            }
        ]
    },
    {
        "name": "Mega Gyarados",
        "label": "超级暴鲤龙",
        "skillGroup1": [
            {
                "en": "Dragon Breath",
                "zh": "龙息"
            }
        ],
        "skillGroup2": [
            {
                "en": "Waterfall",
                "zh": "攀瀑"
            }
        ]
    },
    {
        "name": "Ho-Oh",
        "label": "凤王",
        "skillGroup1": [
            {
                "en": "Fly",
                "zh": "飞翔"
            },
            {
                "en": "Fire Spin",
                "zh": "火焰漩涡"
            }
        ],
        "skillGroup2": [
            {
                "en": "Flamethrower",
                "zh": "喷射火焰"
            },
            {
                "en": "Sky Attack",
                "zh": "神鸟猛击"
            }
        ]
    },
    {
        "name": "Hoopa",
        "label": "胡帕",
        "skillGroup1": [
            {
                "en": "Phantom Force",
                "zh": "潜灵奇袭"
            },
            {
                "en": "Shadow Ball",
                "zh": "暗影球"
            }
        ],
        "skillGroup2": [
            {
                "en": "Hyperspace Hole",
                "zh": "异次元洞"
            },
            {
                "en": "Trick",
                "zh": "戏法"
            }
        ]
    },
    {
        "name": "Inteleon",
        "label": "千面避役",
        "skillGroup1": [
            {
                "en": "Fell Stinger",
                "zh": "致命针刺"
            },
            {
                "en": "Acrobatics",
                "zh": "杂技"
            }
        ],
        "skillGroup2": [
            {
                "en": "Snipe Shot",
                "zh": "狙击"
            },
            {
                "en": "Liquidation",
                "zh": "水流破裂"
            }
        ]
    },
    {
        "name": "Lapras",
        "label": "拉普拉斯",
        "skillGroup1": [
            {
                "en": "Water Pulse",
                "zh": "水之波动"
            },
            {
                "en": "Perish Song",
                "zh": "终焉之歌"
            }
        ],
        "skillGroup2": [
            {
                "en": "Bubble Beam",
                "zh": "泡沫光线"
            },
            {
                "en": "Ice Beam",
                "zh": "冰冻光束"
            }
        ]
    },
    {
        "name": "Latias",
        "label": "拉帝亚斯",
        "skillGroup1": [
            {
                "en": "Mist Ball",
                "zh": "迷雾球"
            },
            {
                "en": "Dragon Cheer",
                "zh": "龙之舞"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dragon Pulse",
                "zh":"龙之波动"
            },
            {
                "en": "Dragon Breath",
                "zh": "龙息"
            }
        ]
    },
    {
        "name": "Latios",
        "label": "拉帝欧斯",
        "skillGroup1": [
            {
                "en": "Luster Purge",
                "zh": "洁净光芒"
            },
            {
                "en": "Telekinesis",
                "zh": "意念移物"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dragon Pulse",
                "zh": "龙之波动"
            },
            {
                "en": "Draco Meteor",
                "zh": "流星群"
            }
        ]
    },
    {
        "name": "Leafeon",
        "label": "叶伊布",
        "skillGroup1": [
            {
                "en": "Razor Leaf",
                "zh": "飞叶快刀"
            },
            {
                "en": "Solar Blade",
                "zh": "日光刃"
            }
        ],
        "skillGroup2": [
            {
                "en": "Aerial Ace",
                "zh": "燕返"
            },
            {
                "en": "Leaf Blade",
                "zh": "叶刃"
            }
        ]
    },
    {
        "name": "Lucario",
        "label": "路卡利欧",
        "skillGroup1": [
            {
                "en": "Extreme Speed",
                "zh": "神速"
            },
            {
                "en": "Power-Up Punch",
                "zh": "增强拳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Bone Rush",
                "zh": "鼓棒乱打"
            },
            {
                "en": "Close Combat",
                "zh": "近身战"
            }
        ]
    },
    {
        "name": "Mega Lucario",
        "label": "超级路卡利欧",
        "skillGroup1": [
            {
                "en": "Power-Up Punch",
                "zh":"增强拳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Close Combat",
                "zh":"近身战"
            }
        ]
    },
    {
        "name": "Machamp",
        "label": "怪力",
        "skillGroup1": [
            {
                "en": "Close Combat",
                "zh": "近身战"
            },
            {
                "en": "Cross Chop",
                "zh": "十字劈"
            }
        ],
        "skillGroup2": [
            {
                "en": "Dynamic Punch",
                "zh": "爆裂拳"
            },
            {
                "en": "Submission",
                "zh": "深渊翻滚"
            }
        ]
    },
    {
        "name": "Mamoswine",
        "label": "象牙猪",
        "skillGroup1": [
            {
                "en": "Icicle Crash",
                "zh": "冰柱坠击"
            },
            {
                "en": "Ice Fang",
                "zh": "冰冻牙"
            }
        ],
        "skillGroup2": [
            {
                "en": "High Horsepower",
                "zh": "十万马力"
            },
            {
                "en": "Earthquake",
                "zh": "地震"
            }
        ]
    },
    {
        "name": "Meowscarada",
        "label": "魔幻假面喵",
        "skillGroup1": [
            {
                "en": "Flower Trick",
                "zh": "千变万花"
            },
            {
                "en": "Night Slash",
                "zh": "暗袭要害"
            }
        ],
        "skillGroup2": [
            {
                "en": "Double Team",
                "zh": "影子分身"
            },
            {
                "en": "Trailblaze",
                "zh": "起草"
            }
        ]
    },
    {
        "name": "Meowth",
        "label": "喵喵",
        "skillGroup1": [
            {
                "en": "Pay Day",
                "zh": "聚宝功"
            },
            {
                "en": "Fury Swipes",
                "zh": "乱抓"
            }
        ],
        "skillGroup2": [
            {
                "en": "Feint Attack",
                "zh": "出奇一击"
            },
            {
                "en": "Assurance",
                "zh": "恶意追击"
            }
        ]
    },
    {
        "name": "Metagross",
        "label": "巨金怪",
        "skillGroup1": [
            {
                "en": "Meteor Mash",
                "zh": "彗星拳"
            },
            {
                "en": "Gyro Ball",
                "zh": "陀螺球"
            }
        ],
        "skillGroup2": [
            {
                "en": "Zen Headbutt",
                "zh": "意念头锤"
            },
            {
                "en": "Magnet Rise",
                "zh": "电磁漂浮"
            }
        ]
    },
    {
        "name": "Mew",
        "label": "梦幻",
        "skillGroup1": [
            {
                "en": "Electro Ball",
                "zh": "电球"
            },
            {
                "en": "Solar Beam",
                "zh": "日光束"
            },
            {
                "en": "Surf",
                "zh": "冲浪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Coaching",
                "zh": "指导"
            },
            {
                "en": "Light Screen",
                "zh": "光墙"
            },
            {
                "en": "Agility",
                "zh": "高速移动"
            }
        ]
    },
    {
        "name": "MewtwoX",
        "label": "超梦X",
        "skillGroup1": [
            {
                "en": "Future Sight",
                "zh": "预知未来"
            },
            {
                "en": "Psystrike",
                "zh": "精神击破"
            }
        ],
        "skillGroup2": [
            {
                "en": "Recover",
                "zh": "自我再生"
            },
            {
                "en": "Teleport",
                "zh": "瞬间移动"
            }
        ]
    },
    {
        "name": "MewtwoY",
        "label": "超梦Y",
        "skillGroup1": [
            {
                "en": "Future Sight",
                "zh": "预知未来"
            },
            {
                "en": "Psystrike",
                "zh": "精神击破"
            }
        ],
        "skillGroup2": [
            {
                "en": "Recover",
                "zh": "自我再生"
            },
            {
                "en": "Teleport",
                "zh": "瞬间移动"
            }
        ]
    },
    {
        "name": "Mimikyu",
        "label": "谜拟Q",
        "skillGroup1": [
            {
                "en": "Play Rough",
                "zh": "嬉闹"
            },
            {
                "en": "Shadow Claw",
                "zh": "暗影爪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Shadow Sneak",
                "zh": "影子偷袭"
            },
            {
                "en": "Trick Room",
                "zh": "戏法空间"
            }
        ]
    },
    {
        "name": "Miraidon",
        "label": "密勒顿",
        "skillGroup1": [
            {
                "en": "Charge Beam",
                "zh": "充电光束"
            },
            {
                "en": "Electro Drift",
                "zh": "闪电猛冲"
            }
        ],
        "skillGroup2": [
            {
                "en": "Thunder",
                "zh": "打雷"
            },
            {
                "en": "Parabolic Charge",
                "zh": "抛物面充电"
            }
        ]
    },
    {
        "name": "Mr.Mime",
        "label": "魔墙人偶",
        "skillGroup1": [
            {
                "en": "Confusion",
                "zh": "念力"
            },
            {
                "en": "Psychic",
                "zh": "精神强念"
            }
        ],
        "skillGroup2": [
            {
                "en": "Barrier",
                "zh": "屏障"
            },
            {
                "en": "Power Swap",
                "zh": "力量互换"
            }
        ]
    },
    {
        "name": "Ninetales",
        "label": "阿罗拉九尾",
        "skillGroup1": [
            {
                "en": "Avalanche",
                "zh": "雪崩"
            },
            {
                "en": "Dazzling Gleam",
                "zh": "魔法闪耀"
            }
        ],
        "skillGroup2": [
            {
                "en": "Blizzard",
                "zh": "暴风雪"
            },
            {
                "en": "Aurora Veil",
                "zh": "极光幕"
            }
        ]
    },
    {
        "name": "Pawmot",
        "label": "巴布土拨",
        "skillGroup1": [
            {
                "en": "Thunder Punch",
                "zh":"雷电拳"
            },
            {
                "en": "Supercell Slam",
                "zh":"闪电强袭"
            }
        ],
        "skillGroup2": [
            {
                "en": "Volt Switch",
                "zh":"伏特替换"
            },
            {
                "en": "Mach Punch",
                "zh":"音速拳"
            }
        ]
    },
    {
        "name": "Pikachu",
        "label": "皮卡丘",
        "skillGroup1": [
            {
                "en": "Electro Ball",
                "zh": "电球"
            },
            {
                "en": "Thunder",
                "zh": "打雷"
            }
        ],
        "skillGroup2": [
            {
                "en": "Volt Tackle",
                "zh": "伏特攻击"
            },
            {
                "en": "Thunderbolt",
                "zh": "十万伏特"
            }
        ]
    },
    {
        "name": "Psyduck",
        "label": "可达鸭",
        "skillGroup1": [
            {
                "en": "Surf",
                "zh":"冲浪"
            },
            {
                "en": "Bubble Beam",
                "zh":"泡沫光线"
            }
        ],
        "skillGroup2": [
            {
                "en": "Disable",
                "zh": "定身法"
            },
            {
                "en": "Psychic",
                "zh":"精神强念"
            }
        ]
    },
    {
        "name": "Raichu",
        "label": "阿罗拉雷丘",
        "skillGroup1": [
            {
                "en": "Stored Power",
                "zh": "辅助力量"
            },
            {
                "en": "Electro Ball",
                "zh": "电球"
            }
        ],
        "skillGroup2": [
            {
                "en": "Thunderbolt",
                "zh": "十万伏特"
            },
            {
                "en": "Psychic",
                "zh": "精神强念"
            }
        ]
    },
    {
        "name": "Rapidash",
        "label": "伽勒尔烈焰马",
        "skillGroup1": [
            {
                "en": "Dazzling Gleam",
                "zh": "魔法闪耀"
            },
            {
                "en": "Fairy Wind",
                "zh":"妖精之风"
            }
        ],
        "skillGroup2": [
            {
                "en": "Smart Strike",
                "zh":"修长之角"
            },
            {
                "en": "Agility",
                "zh":"高速移动"
            }
        ]
    },
    {
        "name": "Sableye",
        "label": "勾魂眼",
        "skillGroup1": [
            {
                "en": "Knock Off",
                "zh": "拍落"
            },
            {
                "en": "Shadow Sneak",
                "zh": "影子偷袭"
            }
        ],
        "skillGroup2": [
            {
                "en": "Feint Attack",
                "zh": "出奇一击"
            },
            {
                "en": "Confuse Ray",
                "zh": "奇异之光"
            }
        ]
    },
    {
        "name": "Scizor",
        "label": "巨钳螳螂",
        "skillGroup1": [
            {
                "en": "Bullet Punch",
                "zh": "子弹拳"
            }
        ],
        "skillGroup2": [
            {
                "en": "Double Hit",
                "zh": "二连击"
            },
            {
                "en": "Swords Dance",
                "zh": "剑舞"
            }
        ]
    },
    {
        "name": "Scyther",
        "label": "飞天螳螂",
        "skillGroup1": [
            {
                "en": "Dual Wingbeat",
                "zh": "双翼"
            }
        ],
        "skillGroup2": [
            {
                "en": "Double Hit",
                "zh": "二连击"
            },
            {
                "en": "Swords Dance",
                "zh": "剑舞"
            }
        ]
    },
    {
        "name": "Sirfetch'd",
        "lalbel": "葱油兵",
        "skillGroup1": [
            {
                "en": "Fury Cutter",
                "zh": "连斩"
            },
            {
                "en": "Leaf Blade",
                "zh": "叶刃"
            }
        ],
        "skillGroup2": [
            {
                "en": "Brutal Swing",
                "zh": "狂舞挥打"
            },
            {
                "en": "Detect",
                "zh": "看穿"
            }
        ]
    },
    {
        "name": "Slowbro",
        "label": "呆壳兽",
        "skillGroup1": [
            {
                "en": "Scald",
                "zh": "热水"
            },
            {
                "en": "Surf",
                "zh": "冲浪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Amnesia",
                "zh": "瞬间失忆"
            },
            {
                "en": "Telekinesis",
                "zh": "意念移物"
            }
        ]
    },
    {
        "name": "Snorlax",
        "label": "卡比兽",
        "skillGroup1": [
            {
                "en": "Heavy Slam",
                "zh": "重磅冲撞"
            },
            {
                "en": "Flail",
                "zh": "抓狂"
            }
        ],
        "skillGroup2": [
            {
                "en": "Block",
                "zh": "挡路"
            },
            {
                "en": "Yawn",
                "zh": "哈欠"
            }
        ]
    },
    {
        "name": "Suicune",
        "label": "水君",
        "skillGroup1": [
            {
                "en": "Whirlpool",
                "zh":"潮旋"
            },
            {
                "en": "Surf",
                "zh": "冲浪"
            }
        ],
        "skillGroup2": [
            {
                "en": "Ice Beam",
                "zh": "冰冻光束"
            },
            {
                "en": "Icy Wind",
                "zh": "冻风"
            }
        ]
    },
    {
        "name": "Sylveon",
        "label": "仙子伊布",
        "skillGroup1": [
            {
                "en": "Mystical Fire",
                "zh": "魔法火焰"
            },
            {
                "en": "Hyper Voice",
                "zh": "高音"
            }
        ],
        "skillGroup2": [
            {
                "en": "Draining Kiss",
                "zh": "吸取之吻"
            },
            {
                "en": "Calm Mind",
                "zh": "冥想"
            }
        ]
    },
    {
        "name": "Talonflame",
        "label": "烈箭鹰",
        "skillGroup1": [
            {
                "en": "Flame Charge",
                "zh": "蓄能焰袭"
            },
            {
                "en": "Aerial Ace",
                "zh": "燕返"
            }
        ],
        "skillGroup2": [
            {
                "en": "Fly",
                "zh": "飞翔"
            },
            {
                "en": "Brave Bird",
                "zh": "勇鸟猛攻"
            }
        ]
    },
    {
        "name": "Tinkaton",
        "label": "巨锻匠",
        "skillGroup1": [
            {
                "en": "Gigaton Hammer",
                "zh": "巨力锤"
            },
            {
                "en": "Smack Down",
                "zh": "击落"
            }
        ],
        "skillGroup2": [
            {
                "en": "Ice Hammer",
                "zh": "冰锤"
            },
            {
                "en": "Thief",
                "zh": "小偷"
            }
        ]
    },
    {
        "name": "Trevenant",
        "label": "朽木妖",
        "skillGroup1": [
            {
                "en": "Wood Hammer",
                "zh": "木槌"
            },
            {
                "en": "Curse",
                "zh": "咒术"
            }
        ],
        "skillGroup2": [
            {
                "en": "Horn Leech",
                "zh": "木角"
            },
            {
                "en": "Pain Split",
                "zh": "分担痛楚"
            }
        ]
    },
    {
        "name": "Tsareena",
        "label": "甜冷美后",
        "skillGroup1": [
            {
                "en": "Triple Axel",
                "zh": "三旋击"
            },
            {
                "en": "Stomp",
                "zh": "踩踏"
            }
        ],
        "skillGroup2": [
            {
                "en": "Trop Kick",
                "zh": "热带踢"
            },
            {
                "en": "Grassy Glide",
                "zh": "青草滑梯"
            }
        ]
    },
    {
        "name": "Tyranitar",
        "label": "班吉拉斯",
        "skillGroup1": [
            {
                "en": "Dark Pulse",
                "zh": "恶之波动"
            },
            {
                "en": "Stone Edge",
                "zh": "尖石攻击"
            }
        ],
        "skillGroup2": [
            {
                "en": "Ancient Power",
                "zh": "原始之力"
            },
            {
                "en": "Sand Tomb",
                "zh": "流沙深渊"
            }
        ]
    },
    {
        "name": "Umbreon",
        "label": "月亮伊布",
        "skillGroup1": [
            {
                "en": "Mean Look",
                "zh": "黑色目光"
            },
            {
                "en": "Foul Play",
                "zh": "移花接木"
            }
        ],
        "skillGroup2": [
            {
                "en": "Wish",
                "zh": "祈愿"
            },
            {
                "en": "Snarl",
                "zh": "大声咆哮"
            }
        ]
    },
    {
        "name": "Urshifu_Single",
        "label": "武道熊师-一击流",
        "skillGroup1": [
            {
                "en": "Wicked Blow",
                "zh": "暗冥强击"
            }
        ],
        "skillGroup2": [
            {
                "en": "Throat Chop",
                "zh": "地狱突刺"
            }
        ]
    },
    {
        "name": "Urshifu_Rapid",
        "label": "武道熊师-连击流",
        "skillGroup1": [
            {
                "en": "Surging Strikes",
                "zh": "水流连打"
            }
        ],
        "skillGroup2": [
            {
                "en": "Liquidation",
                "zh": "水流裂破"
            }
        ]
    },
    {
        "name": "Vaporeon",
        "label": "水伊布",
        "skillGroup1": [
            {
                "en": "Hydro Pump",
                "zh": "水炮"
            },
            {
                "en": "Muddy Water",
                "zh": "浊流"
            }
        ],
        "skillGroup2": [
            {
                "en": "Aqua Ring",
                "zh": "水流环"
            },
            {
                "en": "Flip Turn",
                "zh": "急速折返"
            }
        ]
    },
    {
        "name": "Venusaur",
        "label": "妙蛙花",
        "skillGroup1": [
            {
                "en": "Sludge Bomb",
                "zh": "污泥炸弹"
            },
            {
                "en": "Giga Drain",
                "zh": "终极吸取"
            }
        ],
        "skillGroup2": [
            {
                "en": "Solar Beam",
                "zh": "日光束"
            },
            {
                "en": "Petal Dance",
                "zh": "花瓣舞"
            }
        ]
    },
    {
        "name": "Wigglytuff",
        "label": "胖可丁",
        "skillGroup1": [
            {
                "en": "Double Slap",
                "zh": "连环巴掌"
            },
            {
                "en": "Dazzling Gleam",
                "zh": "魔法闪耀"
            }
        ],
        "skillGroup2": [
            {
                "en": "Rollout",
                "zh": "滚动"
            },
            {
                "en": "Sing",
                "zh": "唱歌"
            }
        ]
    },
    {
        "name": "Zacian",
        "label": "苍响",
        "skillGroup1": [
            {
                "en": "Metal Claw",
                "zh": "金属爪"
            },
            {
                "en": "Sacred Sword",
                "zh": "圣剑"
            }
        ],
        "skillGroup2": [
            {
                "en": "Agility",
                "zh": "高速移动"
            },
            {
                "en": "Play Rough",
                "zh": "嬉闹"
            }
        ]
    },
    {
        "name": "Zeraora",
        "label": "捷拉奥拉",
        "skillGroup1": [
            {
                "en": "Volt Switch",
                "zh": "伏特替换"
            },
            {
                "en": "Spark",
                "zh": "电光"
            }
        ],
        "skillGroup2": [
            {
                "en": "Discharge",
                "zh": "放电"
            },
            {
                "en": "Wild Charge",
                "zh": "疯狂伏特"
            }
        ]
    },
    {
        "name": "Zoroark",
        "label": "索罗亚克",
        "skillGroup1": [
            {
                "en": "Shadow Claw",
                "zh": "暗影爪"
            },
            {
                "en": "Cut",
                "zh": "居合劈"
            }
        ],
        "skillGroup2": [
            {
                "en": "Night Slash",
                "zh": "暗袭要害"
            },
            {
                "en": "Feint Attack",
                "zh": "出奇一击"
            }
        ]
    }
]


// 是否选择
dict.whetherOrNot = [
    {
        "label": "是",
        "name":"yes",
        "value": "1"
    },
    {
        "label": "否",
        "name":"no",
        "value": "2"
    }
]
export default dict


// WEBPACK FOOTER //
// ./src/utils/dict.js